/** List of scopes for each integration */
export const INTEGRATION_SCOPES = {
  autodesk: ["data:read", "data:write"],
  procore: []
};

/** Window message sent when an integration authorization is canceled */
export const CANCELED_AUTHORIZATION_MESSAGE = "OAUTH_ERROR_USER_CANCELED";

/** Error message sent when a re-authorization workflow was not completed */
export const REAUTHORIZATION_NOT_COMPLETED = "reauthorization_not_completed";

/** List of known error codes related to integrations returned by the CoreAPI backend */
export const INTEGRATION_ERROR_CODES = {
  /* eslint-disable @typescript-eslint/naming-convention -- names given by backend */
  /** Returned when a 3rd party integration failed to authenticate the user */
  authentication_error: "authentication_error",
  /** Returned when the token of a 3rd party integration is invalid */
  invalid_token: "invalid_token",
  /** Returned when the token of a 3rd party integration has invalid scopes */
  invalid_scope: "invalid_scope",
  /** Returned when the user has no access token for the integration */
  no_authorization_token: "no_authorization_token"
  /* eslint-enable @typescript-eslint/naming-convention */
};